module.exports = __webpack_public_path__ + "img/img14.394acd95.svg";